module.exports = __webpack_public_path__ + "static/media/c2.a44e6e43.png";